import LivePlayDirector from './LivePlayDirector';

// TODO: type this — Vuex module context
/* eslint-disable @typescript-eslint/no-explicit-any */
type Ctx = any;
/* eslint-enable @typescript-eslint/no-explicit-any */

interface LiveState {
    connected: boolean;
    sessionId: string | null;
    director: LivePlayDirector | null;
    reconnectAttempts: number;
    reconnectFailed: boolean;
}

const LivePlayState = {
    namespaced: true,
    state: {
        connected: false,
        sessionId: null,
        director: null,
        reconnectAttempts: 0,
        reconnectFailed: false,
    } as LiveState,
    mutations: {
        setDirector(state: LiveState, director: LivePlayDirector): void {
            state.director = director;
        },
        setSessionId(state: LiveState, sessionId: string): void {
            state.sessionId = sessionId;
        },
        setConnected(state: LiveState, connected: boolean): void {
            state.connected = connected;
        },
        setReconnectAttempts(state: LiveState, n: number): void {
            state.reconnectAttempts = n;
        },
        setReconnectFailed(state: LiveState, failed: boolean): void {
            state.reconnectFailed = failed;
        },
    },
    actions: {
        addCharacter({ state }: Ctx, { image, pos, mapId }: { image: unknown; pos: unknown; mapId: string }): void {
            state.director.addCharacter(image, pos, mapId);
        },
        removeCharacter({ state }: Ctx, { characterId }: { characterId: string }): void {
            state.director.removeCharacter(characterId);
        },
        async updateCampaignObject(
            { state }: Ctx,
            { collection, id, patch }: { collection: string; id: string; patch: unknown },
        ): Promise<unknown> {
            return await state.director.updateCampaignObject(collection, id, patch);
        },
        async addCampaignObject(
            { state }: Ctx,
            { collection, item }: { collection: string; item: unknown },
        ): Promise<unknown> {
            return await state.director.addCampaignObject(collection, item);
        },
        async removeCampaignObject(
            { state }: Ctx,
            { collection, id }: { collection: string; id: string },
        ): Promise<unknown> {
            return await state.director.removeCampaignObject(collection, id);
        },
        reconnect({ state }: Ctx): Promise<void> {
            return state.director.reconnect();
        },
    },
};

export default LivePlayState;
